import type { MessageKey } from "../i18n/dictionaries";
import type { IconName } from "../ui/icons";

// The routing skeleton — routes RESERVED for the coming screens (Trust Foundation:
// home/profile/consents/messages; C0: proposal). The party realm has NO grants, so —
// unlike the staff console's grant-gated nav — every route is visible when authenticated;
// there is nothing to gate (the API + party_self RLS are the boundary). Each route carries
// the founder's outline icon for the left-sidebar nav.
export interface CustomerRoute {
  key: string;
  path: string;
  labelKey: MessageKey;
  icon: IconName;
  /** Renders the nav entry as a filled primary call-to-action (the "Teklif Al" door —
   *  the ONE write a returning customer initiates from their own page). */
  primary?: boolean;
}

export const ROUTES: CustomerRoute[] = [
  { key: "home", path: "/home", labelKey: "nav.home", icon: "home" },
  // The primary action — a logged-in customer requests a new quote from their own page
  // (POST /v1/customer/quote-requests). Pinned near the top and styled as a filled CTA.
  { key: "quote", path: "/teklif-al", labelKey: "nav.quote", icon: "plus", primary: true },
  { key: "policies", path: "/policies", labelKey: "nav.policies", icon: "vault" },
  { key: "household", path: "/household", labelKey: "nav.household", icon: "household" },
  { key: "renewals", path: "/renewals", labelKey: "nav.renewals", icon: "calendar" },
  { key: "claims", path: "/claims", labelKey: "nav.claims", icon: "protection" },
  { key: "proposal", path: "/proposal", labelKey: "nav.proposal", icon: "suggestion" },
  { key: "consents", path: "/consents", labelKey: "nav.consents", icon: "document" },
  { key: "messages", path: "/messages", labelKey: "nav.messages", icon: "conversation" },
  { key: "profile", path: "/profile", labelKey: "nav.profile", icon: "member" },
];
